import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { DeleteWorkbookVersionsRequest } from '../ServerApi/requests/DeleteWorkbookVersionsRequest';
import { GetWorkbookVersionsRequest, IGetWorkbookVersionsResult } from '../ServerApi/requests/getWorkbookVersionsRequest';
import { IWorkbookRevision } from '../ServerApi/types/IContentRevision';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';

export class WorkbookRevisions extends Resource<IWorkbookRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetWorkbookVersionsRequest,
      (result: IGetWorkbookVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteWorkbookVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('WorkbookRevisions', WorkbookRevisions);
